<a
  href="#"
  id="toTopBtn"
  class="cd-top text-replace js-cd-top cd-top--is-visible cd-top--fade-out"
  data-abc="true"
></a>
